import { RestaurantDealCard } from '@/features/restaurants/restaurant-deal-card'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'
import { cn } from '@/utils/styles/cn'

export function RestaurantDetailDeals() {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant?.deals?.length) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.DEALS}
            title="restaurants.detail.deals.title"
        >
            <div
                className={cn(
                    'grid grid-cols-1 gap-4',
                    restaurant.deals.length > 2 ? 'md:grid-cols-2 lg:grid-cols-3' : 'md:grid-cols-2'
                )}
            >
                {restaurant.deals?.map((deal) => {
                    return (
                        <RestaurantDealCard
                            key={'restaurant-detail-content' + deal.uuid}
                            deal={deal}
                        />
                    )
                })}
            </div>
        </RestaurantDetailSection>
    )
}
